import { asyncRouterMap, constantRouterMap } from '@/router'
import { getUserInfo, getMenus } from '@/api/login'

import store from '../index.js'
var userInfo = null
// 企业用户标识
const companyRoleId = 'company_manager'

/**
 * 根据当前登录企业用户roleId过滤企业用户的菜单路由
 * @param asyncRouterMap
 */
function filterRouterMap (asyncRouterMap) {
  let arr = []
  // 当前用户是否是企业员工
  if (userInfo && userInfo.userType == 5) {
    // console.log(asyncRouterMap)
    for (let i = 0; i < asyncRouterMap.length; i++) {
      let route = asyncRouterMap[i]
      // console.log(route.meta.roles.includes(companyRoleId))

      if (route.meta && route.meta.roles && route.meta.roles.length > 0 && route.meta.roles.includes(companyRoleId)) {
        arr.push(route)
      }
    }
  } else {
    arr = asyncRouterMap
  }
  // console.log(arr)
  return arr
}
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission (roles, route) {
  if (route.meta && route.meta.roles) {
    let flag = roles.some(role => route.meta.roles.indexOf(role) > -1)
    return flag
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter (asyncRouterMap, roles) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    funcode: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
      // console.log(state.routers)
    },
    SET_CODE: (state, code) => {
      state.funcode = code
    }
  },
  actions: {
    async GenerateRoutes ({ commit }, data) {
      await getLoginUserInfo()
      await getMenusInfo()
      return new Promise(resolve => {
        let roles = (sessionStorage.getItem('auth') ? JSON.parse(sessionStorage.getItem('auth')) : [])
        commit('SET_PERMISSIONlIST', roles)
        // const { roles } = data
        let accessedRouters
        let routerMap = filterRouterMap(asyncRouterMap)
        if (roles.includes('auth-all')) { // 包含所有权限
          accessedRouters = routerMap
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    // 根据application获取功能码
    GenerateFunction ({ commit }, data) {
      return new Promise(resolve => {
        let funcode = data
        commit('SET_CODE', funcode)
        resolve()
      })
    }
  }
}

// 获取用户信息
async function getLoginUserInfo () {
  await getUserInfo()
    .then(res => {
      // console.log('123=', res)
      if (res.code === '000000') {
        if (res.data) {
          let data = res.data
          let systemInfo = sessionStorage.getItem('userInfo')
          if (systemInfo) {
            systemInfo = JSON.parse(systemInfo)
          } else {
            systemInfo = {}
          }
          systemInfo.nickName = data.nickName || data.account || ''
          systemInfo.userType = data.userType || '' // 1企业  2集团 3供电所 4监管单位
          systemInfo.projectId = data.projectId || ''
          systemInfo.userId = data.userId || ''
          userInfo = systemInfo
          store.dispatch('setUserInfo', systemInfo)
          store.dispatch('setUserId', systemInfo.userId)
          let isSingleCompany = systemInfo.userType == 1 || systemInfo.userType == 5
          store.dispatch('setIsProjectUser', isSingleCompany)
          if (isSingleCompany) {
            store.dispatch('setProjectId', systemInfo.projectId)
          }
        }
      } else {
        console.log(res.message)
      }
    }).catch(err => {
      console.log(err)
    })
}

export default permission

async function getMenusInfo () {
  let resData = await getMenus()
  sessionStorage.removeItem('auth')
  if (resData) {
    let roles = resData || []
    // roles = ['detection', 'electricalParameterReport'] // 先给所有权限
    sessionStorage.setItem('auth', JSON.stringify(roles))
  }
}
